import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { themeConfig, DialogSize } from '@gap/shared/theme'
import { TabProps } from "@mui/material/Tab"
import { useGapDialogStore } from './GapDialogStore'
import { GapDialogAction } from './GapDialogActionButton'

export interface GapDialogTab {
   label: string
   startIcon?: TabProps['icon']
   component: React.ReactNode
   size?: DialogSize
   buttons?: {
      primary?: GapDialogAction
      secondary?: GapDialogAction
      cancel?: GapDialogAction | boolean
   }
}

export default observer(function GapDialogTabs() {
   const gapDialogStore = useGapDialogStore()

   const GapTabs = useMemo(() => {
      return gapDialogStore.sp.tabs?.map((option, index) => <Tab icon={option.startIcon} iconPosition="start" key={option.label} value={index} label={option.label} sx={{ textTransform: "none", minWidth: '10px', p: 1, minHeight: '20px' }} />)
   }, [gapDialogStore.sp.tabs])

   if (!gapDialogStore.sp.tabs) {
      return null
   }

   return <Tabs value={gapDialogStore.tabIndex} onChange={gapDialogStore.changeTabs} sx={{
      // All this is is to ensure that the selected tab bottom border appears on top of the bottom-border for the entire Tabs component
      position: 'relative',
      minHeight: '40px',
      '&::before': {
         content: '""',
         position: 'absolute',
         bottom: 0,
         left: 0,
         width: '100%',
         height: '1px',
         backgroundColor: themeConfig.primary[200],
         zIndex: 0,
      },
      '.MuiTabs-indicator': {
         position: 'block',
         zIndex: 1,
      },
      '.MuiTab-root': {
         zIndex: 1,
      },
      mb: 3
   }}>
      {GapTabs}
   </Tabs>
})
